export enum ACTRight {
  None = 0,
  Edit = 1 << 0,
  Show = 1 << 1,
  All = ~(~0 << 2),
}
